// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z8GN","name":"styles_name__r9b6u","phone":"styles_phone__1MfT3"};